import { Browser } from "./browser";

export class Platform {
    static readonly isWindows = Browser.userAgent.indexOf('Windows');
    static readonly isMacintosh = Browser.userAgent.indexOf('Macintosh') >= 0;
    static readonly isLinux = Browser.userAgent.indexOf('Linux') >= 0;
    static readonly isWeb = true;
}